const choices = {
    0: '0',
    1: '1 an',
    2: '2 ans',
};

export default choices;
